import { useMutation } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { baseClient } from 'builder/modules/apiClient'
import { actions } from 'builder/modules/interview/interviewModule'
import { Interview } from 'builder/modules/interview/types'
import { queryClient } from 'builder/components/Providers/Providers'

export const useCreateInterviewFromQuestionTemplate = () => {
  const dispatch = useDispatch()
  return useMutation(
    ['useCreateInterviewFromQuestionTemplate'],
    async (questionTemplateId?: number): Promise<Interview> => {
      const res = await baseClient.post(
        // eslint-disable-next-line max-len
        `/interview_prep/interviews/create_from_template?question_template_id=${questionTemplateId}`,
      )
      return res.data
    },
    {
      onSuccess: res => {
        dispatch(actions.setInterviewId(res.id))
        queryClient.invalidateQueries(['useInterviews'])
        queryClient.invalidateQueries(['useInterview'])
        queryClient.invalidateQueries(['useDailySuggestions'])
      },
    },
  )
}
